<template>
    <Listbox v-model="selected" class="mb-2 sm:m-0">
        <div class="relative">
            <input
                type="hidden"
                :name="inputId"
                @input="selected?.value"
                :value="selected?.value"
            />
            <ListboxLabel v-if="label" :class="labelStyles">
                {{ label }}
            </ListboxLabel>
            <ListboxButton
                class="text-sm font-medium leading-tight text-black/95 dark:text-slate-100 focus:outline-slate-300 focus:ring-2 focus:ring-slate-200 rounded-lg px-3 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 active:bg-slate-100 dark:active:bg-slate-700 transition-colors"
                :class="inputStyles"
            >
                <div class="gap-2 flex items-center">
                    <div
                        class="w-5 h-5 relative hidden sm:block"
                        v-if="showIcon"
                    >
                        <i class="fa-solid fa-bars-sort fa-sm"></i>
                    </div>
                    <div class="gap-1 flex">
                        <p
                            class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-tight"
                        >
                            {{ selected?.name }}
                        </p>
                        <div class="h-5 w-5 relative flex items-center">
                            <i class="fa-solid fa-sm fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
            </ListboxButton>

            <transition
                leave-active-class="transition duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <ListboxOptions
                    class="absolute top-full p-2 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 justify-start items-start flex focus:outline-none z-10"
                    :class="optionsStyles"
                >
                    <div
                        class="grow shrink basis-0 flex-col justify-start items-start flex"
                    >
                        <ListboxOption
                            v-for="(option, i) in options"
                            :key="i"
                            :value="option"
                            v-slot="{ active, selected }"
                            @click="$emit('sort', option.value)"
                            as="template"
                            :disabled="option.disabled"
                            :class="{
                                'opacity-50 bg-slate-100 dark:bg-slate-700 cursor-not-allowed':
                                    option.disabled,
                                'cursor-pointer': !option.disabled,
                            }"
                        >
                            <div
                                class="w-full grow min-h-[36px] px-3 py-2 rounded-lg justify-start items-center gap-3 flex text-slate-800 dark:text-slate-100 transition-colors focus:outline-none"
                                :class="{
                                    'bg-slate-100 dark:bg-slate-700': active,
                                    'bg-white dark:bg-slate-800': !active && !selected,
                                }"
                            >
                                <p
                                    class="w-full grow shrink basis-0 text-slate-800 dark:text-slate-100 text-sm font-normal leading-tight whitespace-nowrap"
                                >
                                    {{ option.name }}
                                </p>
                            </div>
                        </ListboxOption>
                    </div>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>
</template>

<script>
import { ref, computed } from 'vue';
import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ListboxLabel,
} from '@headlessui/vue';
export default {
    components: {
        Listbox,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
        ListboxLabel,
    },
    props: {
        options: Array,
        label: String,
        labelStyles: String,
        inputStyles: String,
        optionsStyles: String,
        previouslySelected: String,
        inputId: String,
        placeholder: String,
        showIcon: Boolean,
    },
    setup(props) {
        const computedPreviousValue = computed(() => {
            return props.options.find(
                (option) => option.value === props.previouslySelected
            );
        });

        const selected = ref(computedPreviousValue.value || props.options[0]);

        return { computedPreviousValue, selected };
    },
};
</script>
